/* eslint-disable @typescript-eslint/no-var-requires */
const path = require('path')

const outputPath = process.env.OUTPUT_PATH || process.cwd()

const SEARCH_CACHE_FILE = path.join(outputPath, 'cache', 'search')
const USER_INFO_COOKIE = 'userInfo'
const DB_FOLDER = path.join(outputPath, '.next', 'cache', 'ssg-cache')
const DB_FILE = path.join(DB_FOLDER, 'ssg-values.db')
const TEMPLATE_SEARCH_FILE = path.join(DB_FOLDER, 'search.json')

module.exports = {
  SEARCH_CACHE_FILE,
  USER_INFO_COOKIE,
  DB_FOLDER,
  DB_FILE,
  TEMPLATE_SEARCH_FILE,
}
